const React = require("react");
const constants = require('../constants/deployment.js');

const DeployStatus = function(props) {
	let iconClass = "fa-circle";
	if (props.locked) {
		iconClass = "fa-lock";
	}
	if (props.state === constants.STATE_INVALID) {
		iconClass = "fa-angle-double-right";
	}

	return (
		<span>
            <i className={"fa " + iconClass} aria-hidden></i>
            <span className="deploy-status-text">{props.state}</span>
		</span>
	);
};

module.exports = DeployStatus;
